/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './common';
import './error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "service": {
            "nested": {
              "CreateOtkRequest": {
                "fields": {
                  "clientCredentials": {
                    "type": "squareup.multipass.service.ClientCredentials",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateOtkResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.service.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "oneTimeKey": {
                    "type": "squareup.multipass.service.OneTimeKey",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CheckPasswordRequest": {
                "fields": {
                  "password": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CheckPasswordResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.service.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeleteTwoFactorDetailsRequest": {
                "fields": {
                  "personToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "impersonator": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DeleteTwoFactorDetailsResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.service.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "numDeleted": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RedeemAuthorizationCodeRequest": {
                "fields": {
                  "clientId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientSecret": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "code": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RedeemAuthorizationCodeResponse": {
                "fields": {
                  "error": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreateIdentityTokenFromSessionRequest": {
                "fields": {
                  "excludePii": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateIdentityTokenFromSessionResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.service.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EnrollSecureContactRequest": {
                "nested": {
                  "SecureContactEnrollmentSource": {
                    "values": {
                      "UNKNOWN": 0,
                      "USER_PROVIDED": 1,
                      "TWO_FACTOR_NUMBER": 2
                    }
                  }
                }
              },
              "TwoFactorPromoCohortResponse": {
                "nested": {
                  "CohortType": {
                    "values": {
                      "UNKNOWN": 0,
                      "INCLUDED": 1,
                      "EXCLUDED": 2,
                      "INCLUDED_MANDATORY": 3
                    }
                  }
                }
              },
              "ListActiveSessionsRequest": {
                "fields": {
                  "personToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListActiveSessionsResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.service.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessions": {
                    "type": "squareup.multipass.service.SessionDetails",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.CreateOtkRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.CreateOtkResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.CheckPasswordRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.CheckPasswordResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.DeleteTwoFactorDetailsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.DeleteTwoFactorDetailsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.RedeemAuthorizationCodeRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.RedeemAuthorizationCodeResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.CreateIdentityTokenFromSessionRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.CreateIdentityTokenFromSessionResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.EnrollSecureContactRequest?.nested?.SecureContactEnrollmentSource && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.TwoFactorPromoCohortResponse?.nested?.CohortType && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.ListActiveSessionsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.ListActiveSessionsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateOtkRequest @ squareup/multipass/service/service.proto at 1012:1
 */
export const CreateOtkRequest = $root.lookupType('squareup.multipass.service.CreateOtkRequest');
fixType(CreateOtkRequest);
Builder.createAndAttachToType(CreateOtkRequest);
/**
 * SOURCE CreateOtkResponse @ squareup/multipass/service/service.proto at 1017:1
 */
export const CreateOtkResponse = $root.lookupType('squareup.multipass.service.CreateOtkResponse');
fixType(CreateOtkResponse);
Builder.createAndAttachToType(CreateOtkResponse);
/**
 * SOURCE CheckPasswordRequest @ squareup/multipass/service/service.proto at 1501:1
 */
export const CheckPasswordRequest = $root.lookupType('squareup.multipass.service.CheckPasswordRequest');
fixType(CheckPasswordRequest);
Builder.createAndAttachToType(CheckPasswordRequest);
/**
 * SOURCE CheckPasswordResponse @ squareup/multipass/service/service.proto at 1506:1
 */
export const CheckPasswordResponse = $root.lookupType('squareup.multipass.service.CheckPasswordResponse');
fixType(CheckPasswordResponse);
Builder.createAndAttachToType(CheckPasswordResponse);
/**
 * SOURCE DeleteTwoFactorDetailsRequest @ squareup/multipass/service/service.proto at 1659:1
 */
export const DeleteTwoFactorDetailsRequest = $root.lookupType('squareup.multipass.service.DeleteTwoFactorDetailsRequest');
fixType(DeleteTwoFactorDetailsRequest);
Builder.createAndAttachToType(DeleteTwoFactorDetailsRequest);
/**
 * SOURCE DeleteTwoFactorDetailsResponse @ squareup/multipass/service/service.proto at 1667:1
 */
export const DeleteTwoFactorDetailsResponse = $root.lookupType('squareup.multipass.service.DeleteTwoFactorDetailsResponse');
fixType(DeleteTwoFactorDetailsResponse);
Builder.createAndAttachToType(DeleteTwoFactorDetailsResponse);
/**
 * SOURCE RedeemAuthorizationCodeRequest @ squareup/multipass/service/service.proto at 2041:1
 */
export const RedeemAuthorizationCodeRequest = $root.lookupType('squareup.multipass.service.RedeemAuthorizationCodeRequest');
fixType(RedeemAuthorizationCodeRequest);
Builder.createAndAttachToType(RedeemAuthorizationCodeRequest);
/**
 * SOURCE RedeemAuthorizationCodeResponse @ squareup/multipass/service/service.proto at 2052:1
 */
export const RedeemAuthorizationCodeResponse = $root.lookupType('squareup.multipass.service.RedeemAuthorizationCodeResponse');
fixType(RedeemAuthorizationCodeResponse);
Builder.createAndAttachToType(RedeemAuthorizationCodeResponse);
/**
 * SOURCE CreateIdentityTokenFromSessionRequest @ squareup/multipass/service/service.proto at 2064:1
 */
export const CreateIdentityTokenFromSessionRequest = $root.lookupType('squareup.multipass.service.CreateIdentityTokenFromSessionRequest');
fixType(CreateIdentityTokenFromSessionRequest);
Builder.createAndAttachToType(CreateIdentityTokenFromSessionRequest);
/**
 * SOURCE CreateIdentityTokenFromSessionResponse @ squareup/multipass/service/service.proto at 2069:1
 */
export const CreateIdentityTokenFromSessionResponse = $root.lookupType('squareup.multipass.service.CreateIdentityTokenFromSessionResponse');
fixType(CreateIdentityTokenFromSessionResponse);
Builder.createAndAttachToType(CreateIdentityTokenFromSessionResponse);
/**
 * Add a secure contact method for a given person.
 *
 * SOURCE EnrollSecureContactRequest @ squareup/multipass/service/service.proto at 2286:1
 */
export const EnrollSecureContactRequest = {};
/**
 * SOURCE SecureContactEnrollmentSource @ squareup/multipass/service/service.proto at 2299:3
 */
EnrollSecureContactRequest.SecureContactEnrollmentSource = $root.lookupEnum('squareup.multipass.service.EnrollSecureContactRequest.SecureContactEnrollmentSource').values;
/**
 * Merchant cohorts response. Only merchants with a stored cohort setting will be included in the response.
 *
 * SOURCE TwoFactorPromoCohortResponse @ squareup/multipass/service/service.proto at 2469:1
 */
export const TwoFactorPromoCohortResponse = {};
/**
 * SOURCE CohortType @ squareup/multipass/service/service.proto at 2470:3
 */
TwoFactorPromoCohortResponse.CohortType = $root.lookupEnum('squareup.multipass.service.TwoFactorPromoCohortResponse.CohortType').values;
/**
 * List all active sessions for the provided user.
 *
 * SOURCE ListActiveSessionsRequest @ squareup/multipass/service/service.proto at 2643:1
 */
export const ListActiveSessionsRequest = $root.lookupType('squareup.multipass.service.ListActiveSessionsRequest');
fixType(ListActiveSessionsRequest);
Builder.createAndAttachToType(ListActiveSessionsRequest);
/**
 * Details of active sessions for a provided user.
 *
 * SOURCE ListActiveSessionsResponse @ squareup/multipass/service/service.proto at 2651:1
 */
export const ListActiveSessionsResponse = $root.lookupType('squareup.multipass.service.ListActiveSessionsResponse');
fixType(ListActiveSessionsResponse);
Builder.createAndAttachToType(ListActiveSessionsResponse);